/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var EllipsisHIcon = createIcon({
  name: 'EllipsisHIcon',
  height: 512,
  width: 512,
  svgPath: 'M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z',
  yOffset: '',
  xOffset: '',
  transform: ''
});
export default EllipsisHIcon;